export default "__VITE_ASSET__CqzL$DIs__"